import { createSelector } from 'reselect';

import { dataFilterTypesSelector } from '../../api/reducers/config';
import { ReduxState } from '../reducers';

const dataFilterLinesAndRegionsEmptySelector: (state: ReduxState) => boolean = createSelector(
  state => state.inform.dataFilter.criteria,
  state => dataFilterTypesSelector(state),
  (criteria, dataFilterTypes) => {
    if (dataFilterTypes.includes('regions') && criteria.regions.length > 0) {
      return false;
    }

    if (dataFilterTypes.includes('lines') && criteria.lines.length > 0) {
      return false;
    }

    return true;
  }
);

export default dataFilterLinesAndRegionsEmptySelector;
